<script setup lang="ts">
import { computed } from 'vue';
import amex from '@/assets/imgs/openpay/card_icon_amex.ico'
import mastercard from '@/assets/imgs/openpay/card_icon_mastercard.ico'
import visa from '@/assets/imgs/openpay/card_icon_visa.ico'
import carnet from '@/assets/imgs/openpay/card_icon_carnet.ico'

interface Props {
    processor: string;
    className?: string;
}

const props = withDefaults(defineProps<Props>(), {
    processor: '',
    className: '',
})

const processorIcon = computed(() => {
    switch (props.processor) {
        case 'american_express':
            return amex
        case 'mastercard':
            return mastercard
        case 'visa':
            return visa
        case 'carnet':
            return carnet
        default:
            return ''
    }
})
</script>

<template>
    <figure :class="[props.className]">
        <img class="w-full" :src="processorIcon" :alt="props.processor">
    </figure>
</template>
